<template>
    <b-modal size="lg" id="comission-run" @shown="filterItems()">
        <template #modal-title>
            <h6 class="fw-bold mb-0 akkurate-green">Run Commission</h6>
        </template>
        <div class="row">
            <div class="col-6 col-md-9">
                <label class="akkurate-dark small" for="acc_types">Frequency </label>
                <multiselect class="mt-2 field-container" v-model="comission_form.frequency" :options="frequency_option"
                    placeholder="Select Frequency">
                </multiselect>
            </div>
            <div class="col mt-auto">
                <b-button @click="submitCommission()" type="submit" :disabled="isSaving"
                    class="akkurate-green-btn btn-size float-right border-0">
                    <span v-if="this.isSaving == true" class="small"><b-spinner small type="grow"
                            label="Spinning"></b-spinner>Processing...</span>
                    <span v-else class="small"><font-awesome-icon class="me-2" :icon="['fas', 'check']" />Run</span>
                </b-button>
            </div>
        </div>
        <hr />
        <div class="row">
            <div class="col-12">
                <form @submit.prevent="submitFormFilters()">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <label class="akkurate-dark small" for="search">Search</label>
                            <b-form-group id="search" label-for="search" class="akkurate-dark">
                                <b-form-input id="search" class="mt-1 field-container fields" type="text"
                                    v-model="form.filter" placeholder="Search by name, code, A/C, phone ...">
                                </b-form-input>
                            </b-form-group>
                        </div>
                        <div class="col">
                            <label class="akkurate-dark small" for="account_number">Account
                                number</label>
                            <b-form-group id="account_number" label-for="account_number" class="akkurate-dark">
                                <b-form-input id="account_number" class="mt-1 field-container fields" type="text"
                                    v-model="form.account_number" placeholder="Enter Account number">
                                </b-form-input>
                            </b-form-group>
                        </div>
                        <!-- <div class="d-grid gap-2 col-md-2 mt-auto d-flex align-content-center justify-content-center">
                            <b-button type="submit" class="akkurate-green-btn akkurate-auth-size w-100"><i
                                    class="fas fa-search me-2"></i>Search</b-button>
                        </div> -->
                        <div class="d-grid gap-2 col-md-2 mt-auto d-flex align-content-center justify-content-center">
                            <b-button type="submit" class="akkurate-green-btn akkurate-auth-size w-100"><i
                                    class="fas fa-search me-2"></i></b-button>
                            <b-button size="sm" @click="showMoreFilter()" title="show more filters" class="ms-2">
                                <i class="fas fa-bars akkurate-small"></i>
                            </b-button>
                        </div>
                    </div>
                    <div class="row mt-2" v-if="showMore">
                        <div class="col-12 col-md-6">
                            <label class="akkurate-dark small" for="loan-re-date">Start Date</label>
                            <b-form-group id="loan-re-date" label-for="loan-re-date">
                                <b-form-input class="mt-1 field-container fields" type="date"
                                    v-model="form.start_date"></b-form-input>
                            </b-form-group>
                        </div>
                        <div class="col-12 col-md-6">
                            <label class="akkurate-dark small" for="loan-re-date">End Date</label>
                            <b-form-group id="loan-re-date" label-for="loan-re-date">
                                <b-form-input class="mt-1 field-container fields" type="date"
                                    v-model="form.end_date"></b-form-input>
                            </b-form-group>
                        </div>
                    </div>
                </form>
            </div>
            <div class="col-12 table_text_size mt-2">
                <b-table striped bordered responsive id="commission-payment-table" :busy.sync="isBusy" :items="rows"
                    :fields="fields" :tbody-tr-class="rowClass" show-empty>
                    <template #table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Loading...</strong>
                        </div>
                    </template>
                    <template #cell(customer)="data">
                        <div>{{ data.item.accounts?.customer?.first_name }} {{ data.item.accounts?.customer?.last_name
                            }}
                        </div>
                    </template>
                    <template #cell(account_number)="data">
                        <div>{{ data.item.accounts?.account_number }}
                        </div>
                    </template>
                    <template #cell(paid_at)="data">
                        <div>{{ formatDate(data.item.paid_at) }}
                        </div>
                    </template>
                    <template #cell(account_type)="data">
                        <div>{{ data.item.accounts?.account_type?.name }}
                        </div>
                    </template>
                </b-table>
            </div>
            <div class="col-12 table_text_size">
                <div class="d-flex justify-content-between">
                    <b-pagination class="mt-1" @change="navigatePage" v-model="currentPage" :total-rows="totalRecords"
                        :per-page="perPage" aria-controls="commission-payment-table"></b-pagination>
                    <div class="col text-end mt-1">
                        <div>{{ currentPage }} - {{ perPage }} of {{ totalRecords }}</div>
                        <b-form-group label="Per Page" label-size="sm" class="mb-0">
                            <b-form-select @change="selectPerPage" id="per-page-select" v-model="perPage"
                                :options="per_page_options" size="sm"></b-form-select>
                        </b-form-group>
                    </div>
                </div>
            </div>
        </div>
        <template #modal-footer="{ ok }">

            <div class="w-100">
                <!-- Emulate built in modal footer ok and cancel button actions -->
                <b-button @click="$bvModal.hide('comission-run')" type="button"
                    class="akkurate-grey-btn border-0 btn-size float-right"><span class="small"><font-awesome-icon
                            class="me-2" :icon="['fas', 'close']" />Close</span>
                </b-button>


            </div>
        </template>
    </b-modal>


</template>

<script>
import Multiselect from "vue-multiselect";
import ApiService from "@/core/services/api.service";
export default {
    components: {
        Multiselect
    },
    data() {
        return {
            ...this.initialState(),
            totalRecords: 0,
            searchFilter: "",
            isLoading: false,
            isSaving: false,
            add_or_edit: 'add',
            institution: "",
            isBusy: false,
            currentPage: 1,
            perPage: 10,
            per_page_options: ['10', '20', '50', '100', '500'],
            frequency_option: ['daily', 'weekly', 'monthly', 'annually'],
            showMore: false,
            comission_form: {
                frequency: [],
            },
            fields: [
                {
                    key: 'id',
                    label: '#'
                },
                {
                    key: 'amount',
                    label: 'Amount'
                },
                {
                    key: 'paid_at',
                    label: 'Paid At',

                },
                {
                    key: 'frequency',
                    label: 'Frequency',

                },
                {
                    key: 'period_key',
                    label: 'Period_Key',

                },
                {
                    key: 'account_type',
                    label: 'Product',

                },
                {
                    key: 'account_number',
                    label: 'Account Number',

                },
                {
                    key: 'customer',
                    label: 'Member Name',

                },
                // {
                //     key: 'customer.external_code',
                //     label: 'Member (Ext.Code)',

                // },
                // {
                //     key: 'customer.mobile',
                //     label: 'Member Mobile',

                // },
                // {
                //     key: 'status',
                //     label: 'Status',
                // },
                // {
                //     key: 'created_at',
                //     label: 'Created',
                // },
                // {
                //     key: 'actions',
                //     label: 'Actions',
                // },
            ],
            rows: [],

        }
    },
    methods: {

        async loadItems() {
            this.isBusy = true;  // Set isBusy to true when data is being loaded

            // var branch_id = this.form.branch ? this.form.branch.id : '';
            // var acc_id = this.form.acc_types?.map(index => index?.id ?? []);

            // this.$Progress.start();  // Start the progress bar

            try {
                const response = await ApiService.post("/commission/paginate", {
                    "page": this.currentPage,
                    "per_page": this.perPage,
                    "filter": this.form.filter,
                    // "branch_id": branch_id,
                    // "account_type_id": acc_id,
                    // "account_number": this.form.account_number,
                    "start_date": this.form.start_date,
                    "end_date": this.form.end_date,
                    "status": this.form.status // Active, Inactive, etc.
                });

                // Handle response and update table data
                this.isBusy = false;  // Set isBusy to false when the data is loaded
                this.$Progress.finish();  // Finish the progress bar

                this.totalRecords = response.data.meta.total;
                this.rows = response.data.data;  // Return data to populate the table
            } catch (error) {
                console.error(error);
                this.isBusy = false;  // Set isBusy to false in case of an error
                this.$Progress.finish();  // Finish the progress bar even if there's an error

                return [];  // Return an empty array in case of error to prevent the table from breaking
            }
        },
        navigatePage(index) {
            this.isBusy = true;
            this.currentPage = index;
            this.loadItems()
        },

        selectPerPage(index) {
            this.perPage = index
            this.loadItems()
        },
        filterItems() {
            console.log("Here");
            this.loadItems();
        },
        async submitCommission() {
            this.isSaving = true;
            // this.$Progress.start();
            // this.form.errors = [];
            console.log("run comission");
            await ApiService.post("/commission/run", this.comission_form)
                .then((response) => {
                    this.isSaving = false;
                    // this.$Progress.finish();
                    toast.fire({
                        icon: "success",
                        title: response.data.message,
                    });
                    // this.isSaving = false;
                    // this.form.reset();
                    // this.comission_form = this.initialState().form;
                })
                .catch((error) => {
                    this.isSaving = false;
                    // this.$Progress.fail();
                    // console.log(error.response.data.message);
                    this.message = error.response.data.message;
                    if (error.response) {
                        this.form.errors = error.response.data.errors;
                    }
                });

        },
        initialState() {
            return {
                form: {
                    branch: {},
                    branch_option: [],
                    acc_types: [],
                    acc_types_option: [],
                    filter: "",
                    account_number: "",
                    start_date: "",
                    end_date: "",
                    status: "",
                    status_option: ['ACTIVE', 'INACTIVE', 'DORMANT', 'CLOSED'],
                },
            };
        },
        rowClass() {
            return 'custom-row-height'
        },
        submitFormFilters() {
            this.loadItems();
        },
        showMoreFilter(){
            this.showMore = !this.showMore
        }
    }

}

</script>
